import React, { useState, useEffect, useRef } from "react";
import moment from "moment";

const CustomTimeSlotsWrapper = ({ children, value, view }) => {
    const [currentTimePosition, setCurrentTimePosition] = useState(null);
    const [isCurrentWeek, setIsCurrentWeek] = useState(false);
    const calendarRef = useRef(null);

    useEffect(() => {
        if (view !== "week") {
            setCurrentTimePosition(null);
            setIsCurrentWeek(false);
            return;
        }

        const updateCurrentTimePosition = () => {
            const now = moment();
            // Use the calendar's displayed date (value) to determine the week range
            const startOfWeek = moment(value).startOf("week");
            const endOfWeek = moment(value).endOf("week");

            // Check if the current time is within the displayed week
            const isWithinWeek = now.isBetween(startOfWeek, endOfWeek, null, "[]");
            setIsCurrentWeek(isWithinWeek);

            if (!isWithinWeek) {
                setCurrentTimePosition(null);
                return;
            }

            // Get the actual height of the calendar's time slots container
            const calendarElement = calendarRef.current?.querySelector(".rbc-time-content");
            const calendarHeight = calendarElement ? calendarElement.offsetHeight : 600; // Fallback to 600px

            // Calculate the position based on the time range (00:00 to 23:59)
            const minTime = moment().startOf("day"); // 00:00
            const maxTime = moment().endOf("day"); // 23:59
            const totalMinutesInRange = maxTime.diff(minTime, "minutes"); // 1440 minutes
            const minutesSinceStart = now.diff(minTime, "minutes");
            const position = (minutesSinceStart / totalMinutesInRange) * calendarHeight;

            setCurrentTimePosition(position);
        };

        updateCurrentTimePosition();
        const interval = setInterval(updateCurrentTimePosition, 60000); // Update every minute

        return () => clearInterval(interval);
    }, [view, value]);

    return (
        <div ref={calendarRef} style={{ position: "relative" }}>
            {children}
            {view === "week" && isCurrentWeek && currentTimePosition !== null && (
                <div
                    style={{
                        position: "absolute",
                        top: `${currentTimePosition}px`,
                        left: 0,
                        right: 0,
                        height: "2px",
                        backgroundColor: "#ff6200", // Orange line
                        zIndex: 100,
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            left: 0,
                            top: "-5px",
                            width: "10px",
                            height: "10px",
                            backgroundColor: "#ff6200",
                            borderRadius: "50%",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            right: 0,
                            top: "-5px",
                            width: "10px",
                            height: "10px",
                            backgroundColor: "#ff6200",
                            borderRadius: "50%",
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default CustomTimeSlotsWrapper;